import React from "react";

function RadioGroup(props) {

	const {options, type, x, y, value, disabled, labelWidth, distance = 100, labelDistance = 30,...addProps} = props
	return <div>
		{options.map((radio, idx) => {
			return (
				<div key={type + "radio" + idx}>
					<label
						htmlFor={type + "radio" + idx}
						style={{
							top: y + 5 + 'px',
							left: x + labelDistance + (idx * distance) + 'px',
							position: 'absolute',
							zIndex: '10',
							height: '16px',
							width: labelWidth ? labelWidth + 'px' : '160px'
						}}
					>{radio}</label>
					<input
						id={type + "radio" + idx}
						style={{
							top: y + 'px',
							left: x + (idx * distance) + 'px',
							position: 'absolute',
							zIndex: '10',
							height: '16px',
							width: '16px'
						}}
						type="radio"
						name={type}
						value={radio}
						disabled={disabled}
						checked={value === radio}
						{...addProps}
					/>
				</div>)
		})}
	</div>

}

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/react/ui/features/RadioGroup/RadioGroup.jsx